<template>
     <div>
          <v-app-bar
               id="home-centered-app-bar"
               app
               style="background-color: white !important"
               height="130"
               absolute
               flat
          >
               <v-container class="py-0 flex-center-y text-center flex-grow">
                    <h3 class="logo-text">Theme Logo Text</h3>
                    <v-tabs
                         class="hidden-sm-and-down"
                         background-color="white"
                         optional
                         centered
                    >
                         <v-tab
                              v-for="(item, i) in items"
                              :key="i"
                              :to="item.route"
                              :exact="item.name === 'Home'"
                              :ripple="false"
                              active-class="text--primary"
                              class="font-weight-bold"
                              min-width="96"
                              text
                         >
                              {{ item.name }}
                         </v-tab>
                    </v-tabs>
               </v-container>

               <v-app-bar-nav-icon
                    class="hidden-md-and-up accent--text"
                    @click="drawer = !drawer"
               />
          </v-app-bar>

          <home-drawer v-model="drawer" :items="items" />
     </div>
</template>
<style scoped>
.logo-text {
     font-size: 2em;
     font-family: Recursive;
     color: primary;
}
</style>
<script>
export default {
     name: 'HomeAppBarCentered',

     components: {
          HomeDrawer: () => import('./Drawer'),
     },

     data: () => ({
          drawer: null,
          items: [
               {
                    name: 'Home',
                    route: '/',
               },
          ],
     }),
}
</script>

<style lang="sass">
#home-app-bar
.v-tabs-slider
     max-width: 24px
     margin: 0 auto

.v-tab
     &::before
          display: none
</style>
